<template>
  <div class="home">
    <GetStarted />
    <Driver class="list_show"/>
    <Works class="list_show"/>
    <!-- <SlideComp class="list_show"/> -->
    <Coupon class="list_show"/>
  </div>
</template>

<script>
// @ is an alias to /src
  import GetStarted from '@/components/home/GetStarted.vue';
  import Driver from '@/components/home/Driver.vue';
  import Works from '@/components/home/Works.vue';
  // import SlideComp from '@/components/home/SlideComp.vue';
  import Coupon from '@/components/home/Coupon.vue';

  export default {
    components: { GetStarted, Driver, Works, Coupon },
    mounted(){
      // const lists = document.querySelectorAll('.list_show')[0]
      // // console.log(lists);
      // const x = lists.getBoundingClientRect()
      // const top = x.top
      // const bottom = x.bottom
      // const height = x.height
      // const y = console.log(top, height, bottom);
    window.addEventListener('scroll', this.scrolling)
      
    },
    computed: {
    },
    methods: {
       scrolling(){
          const elem = document.querySelectorAll('.list_show')
          for (var i = 0; i < elem.length; i++) {
            var listItem = elem[i];
            if (this.visible(listItem)) {
              listItem.classList.add('active')
            }else{
              listItem.classList.remove('active')
            }
          }
          
        },
        visible(arg) {
          const elem = arg.getBoundingClientRect()
          const bottom = elem.bottom
          const height = elem.height
          return (height + window.innerHeight >= bottom)
      }
    }
}

</script>
<style scoped>
  .home{
    position: relative;
    width: 100%;
    margin: 0;
    padding: 0;
    background-color: #F9F1EB;
    padding-bottom: 4rem;
    scroll-behavior: smooth;
  }
  .list_show {
    transform: translate3d(0, 150px, 0);
    transition: all .5s ease-out;
    opacity: 0;
  }
  .active {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
</style>